import React from 'react';
import { bonuses, type Bonus } from '../data/bonuses';
function BonusCover({
  bonus
}: {
  bonus: Bonus;
}) {
  if (bonus.cover) {
    return <img src={bonus.cover} alt={`${bonus.title} cover`} width={1024} height={1024} loading="lazy" className="aspect-[5/4] w-full border-b border-plum-line object-cover object-center" data-id="element-22" data-mp="pj6cm4pkakr0" />;
  }
  return <div aria-hidden="true" className="relative flex h-[230px] items-center justify-center border-b border-plum-line bg-blush sm:h-[265px]" data-id="element-23" data-mp="1u5b71f5c9v8">
      <div className="relative w-[62%] max-w-[260px] aspect-[4/3] overflow-hidden rounded-md bg-cream shadow-cover ring-1 ring-black/5" data-id="element-24" data-mp="5tnll39cd2jt">
        <div className="px-[8%] pt-[8%]" data-id="element-25" data-mp="3szwoh07trs0m">
          <span className="block text-[10px] font-semibold uppercase tracking-[0.18em] text-gold-deep" data-id="element-26" data-mp="3t0yb81y7e2y6">
            Bonus {bonus.number}
          </span>
          <span className="mt-2 block font-display text-[15px] font-bold leading-tight text-plum sm:text-base" data-id="element-27" data-mp="1r9l91knme95t">
            {bonus.title.split(':')[0]}
          </span>
        </div>
        <span className="absolute left-[8%] right-[8%] bottom-[20%] h-px bg-gold" data-id="element-28" data-mp="3dfle77z1102h" />
        <span className="absolute bottom-[8%] left-[8%] font-display text-[10px] italic text-ink-soft" data-id="element-29" data-mp="3ddiokp1sd8ya">
          Memory Care Activity Ready
        </span>
        <span className={`absolute inset-x-0 bottom-0 h-[5%] ${bonus.accent}`} data-id="element-30" data-mp="3n6g20grx87q1" />
      </div>
    </div>;
}
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="w-full bg-plum" data-id="element-31" data-mp="2ugha8dmcdwho">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-32" data-mp="2uik97n5h2zyj">
        <div className="text-center" data-id="element-33" data-mp="38hbhuu1kftfa">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold" data-id="element-34" data-mp="38e5v3lget3mq">
            Also included at no extra cost
          </p>
          <h2 id="bonuses-heading" className="mt-3 font-display font-bold text-white text-3xl sm:text-5xl" data-id="element-35" data-mp="np8dsosv5pmy">
            Five instant-use <span className="italic text-gold" data-id="element-36" data-mp="itauqaq7u56h">bonuses</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-white/80" data-id="element-37" data-mp="3cin00ys8h6bv">
            The volumes give you the system. These five get you running it on
            Monday.
          </p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-38" data-mp="3lk4gii9jza13">
          {bonuses.map((bonus, i) => <article key={bonus.number} className={`flex flex-col overflow-hidden rounded-3xl border border-plum-line bg-plum-card ${i === bonuses.length - 1 ? 'sm:col-span-2 sm:mx-auto sm:w-[calc(50%-8px)]' : ''}`} data-id="element-39" data-mp="3qi5y0yrbz1ag" data-mpi={i}>
              <BonusCover bonus={bonus} data-id="element-40" data-mp="32ra6m2qse83q" />
              <div className="px-5 pb-6 pt-4" data-id="element-41" data-mp="37kv9a83brq99">
                <div className="flex flex-wrap items-center gap-2" data-id="element-42" data-mp="37lwhm4syhyna">
                  <span className="text-[11px] font-semibold uppercase tracking-widest text-white/65" data-id="element-43" data-mp="2a3o1ur5toxfa">
                    Bonus {bonus.number}
                  </span>
                  <span className="rounded-full bg-gold px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-gold-ink" data-id="element-44" data-mp="27kjaisdvi1ik">
                    Free today
                  </span>
                </div>
                <h3 className="mt-2.5 font-display text-xl font-bold leading-snug text-white" data-id="element-45" data-mp="1xksj4zkm02mp">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-sm text-white/80" data-id="element-46" data-mp="1tml0u0ahyt9e">{bonus.body}</p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}